import MediaORM from "@/store/orm-axios/models/Media";

import useAlerts from "@/use/useAlerts.js";

import store from "@/store/store";

export default {
  MANDATE_PDF_CREATE_MERGE_PV(mandateId, meetingId, templates) {
    return new Promise((resolve, reject) => {
      if (!process.env.VUE_APP_IS_WEB) {
        // TODO: use puppeteer lib in desktop
      } else {
        MediaORM.api()
          .MANDATE_PDF_CREATE_MERGE_PV(mandateId, meetingId, templates)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            store.state.showLoaderOverlay = false;
            const { alertErrorAndReport } = useAlerts();
            alertErrorAndReport(
              err,
              "La génération du PDF n'a pas pu être effectuée !",
              "Veuillez vérifier votre connexion Internet."
            );
          });
      }
    });
  },
  MANDATE_PDF_CREATE_MERGE(meetingId, templates, mandateId) {
    return new Promise((resolve, reject) => {
      if (!process.env.VUE_APP_IS_WEB) {
        // TODO: use puppeteer lib in desktop
      } else {
        MediaORM.api()
          .MANDATE_PDF_CREATE_MERGE(meetingId, templates, mandateId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            store.state.showLoaderOverlay = false;
            const { alertErrorAndReport } = useAlerts();
            alertErrorAndReport(
              err,
              "La génération du PDF n'a pas pu être effectuée !",
              "Veuillez vérifier votre connexion Internet."
            );
          });
      }
    });
  },
  MEETING_PDF_CREATE_SAVE_RETURN(meetingId, templates) {
    return new Promise((resolve, reject) => {
      if (!process.env.VUE_APP_IS_WEB) {
        // TODO: use puppeteer lib in desktop
      } else {
        MediaORM.api()
          .MEETING_PDF_CREATE_SAVE_RETURN(meetingId, templates)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            store.state.showLoaderOverlay = false;
            const { alertErrorAndReport } = useAlerts();
            alertErrorAndReport(
              err,
              "La génération du PDF n'a pas pu être effectuée !",
              "Veuillez vérifier votre connexion Internet."
            );
          });
      }
    });
  },
  MEETING_PDF_CREATE_RETURN(meetingId, templates) {
    return new Promise((resolve, reject) => {
      if (!process.env.VUE_APP_IS_WEB) {
        // TODO: use puppeteer lib in desktop
      } else {
        MediaORM.api()
          .MEETING_PDF_CREATE_RETURN(meetingId, templates)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            store.state.showLoaderOverlay = false;
            const { alertErrorAndReport } = useAlerts();
            alertErrorAndReport(
              err,
              "La génération du PDF n'a pas pu être effectuée !",
              "Veuillez vérifier votre connexion Internet."
            );
          });
      }
    });
  },

  CREATE_PDFS_TO_GENERATE_ROW(data) {
    return new Promise((resolve, reject) => {
      if (!process.env.VUE_APP_IS_WEB) {
        // ???: ..
      } else {
        MediaORM.api()
          .CREATE_PDFS_TO_GENERATE_ROW(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      }
    });
  },

  DUMMY_PDF_CREATE_RETURN(templates) {
    return new Promise((resolve, reject) => {
      if (!process.env.VUE_APP_IS_WEB) {
        // TODO: use puppeteer lib in desktop
      } else {
        MediaORM.api()
          .DUMMY_PDF_CREATE_RETURN(templates)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            store.state.showLoaderOverlay = false;
            const { alertErrorAndReport } = useAlerts();
            alertErrorAndReport(
              err,
              "La génération du PDF n'a pas pu être effectuée !",
              "Veuillez vérifier votre connexion Internet."
            );
          });
      }
    });
  },
};
